(function() {
'use strict';

angular
    .module('TR')
    .directive('occupancyDesktop', Occupancy);

function Occupancy($timeout, $route, $document, arrayUtil, occupancyService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            maxRooms: '@',
            maxAge: '@',
            occupancy: '=',
            multiroomDisabled: '=',
            hideGroupBookingLink: '@',
            areaOverride: '@'
        },
        templateUrl: 'partials/home/directivetemplate?type=OccupancyDesktop',
        link: _linker
    };

    function _linker(scope, el) {
        const area = scope.areaOverride || scope.$parent.areaOverride || $route.current.area;
        const limits = TRPCONFIG.Domain.OccupancyLimits[area];
        const wrapper = $('#occupancy-selectors', el);
        const inp = $('.input-occupancy', el);
        let timer;

        const initPos = function() {
            $timeout.cancel(timer);
            timer = $timeout(function() {
                wrapper.position({
                    my: 'right top',
                    of: el,
                    at: 'right bottom',
                    collision: 'fit'
                });
            }, 50);
        };

        scope.ages = arrayUtil.createRange(parseInt(scope.maxAge) || TRPCONFIG.Domain.MaximumChildAge, 0);
        scope.getAdultsLimit = _.memoize(getAdultsLimit);
        scope.getChildrenLimit = _.memoize(getChildrenLimit);
        scope.rooms = arrayUtil.createRange(scope.maxRooms || limits.maxRooms);
        scope.updateOccupancy = updateOccupancy;
        scope.showOccupancyWrapper = showOccupancyWrapper;
        scope.switchWrapper = switchWrapper;

        scope.changeRooms = changeRooms;

        scope.$watch('occupancy', function(val) {
            if (val == null) {
                return;
            }
            scope.occupancyString = scope.multiroomDisabled ?
                                    occupancyService.getOccupancyString() :
                                    occupancyService.getRoomOccupancyString();
        }, true);


        function getAdultsLimit(firstRoom) {
            return arrayUtil.createRange(firstRoom ? limits.maxAdults : 6);
        }

        function getChildrenLimit(firstRoom) {
            return arrayUtil.createRange(firstRoom ? limits.maxChildren : 5, 0);
        }

        function switchWrapper(value) {
            if (value) {
                initPos();
            }
            scope.showWrapper = value;
        }

        function showOccupancyWrapper(e) {
            initPos();
            scope.showWrapper = true;

            // Going to attach another click event which should not be fired
            // in the current event bubble
            e.stopPropagation();

            //this function must be declared locally to prevent it being hoisted to far,
            //and then removed from scope
            let _hideOccupancyWrapper = function _hideOccupancyWrapperFn(e) {
                const isChild = el.find(e.target).length > 0;

                if (!isChild) {
                    scope.$apply(function() {
                        scope.showWrapper = false;
                        $document.off('click.occupancy', _hideOccupancyWrapper);
                    });
                }
            };

            inp.on('keydown', function tab(e) {
                if (e.which === 9 || e.which === 27) {
                    scope.$apply(function() {
                        scope.showWrapper = false;
                    });
                }
            });

            $document.on('click.occupancy', _hideOccupancyWrapper);
        }

        scope.$on('$destroy', function() {
            inp.off('keydown');
            $document.off('click.occupancy');
        });

        function changeRooms() {
            _.each(scope.occupancy, (room, index) => {
                // ensure we have not added a null room to the occupancy array
                room = room || {};
                room.ChildAges = room.ChildAges || [];
                room.Adults = room.Adults || 2;
                scope.occupancy[index] = room;
            });
            updateOccupancy(scope.occupancy);
        }

        function updateOccupancy(o) {
            occupancyService.setOccupancy(o, true);
            scope.occupancyString = scope.multiroomDisabled ?
                                    occupancyService.getOccupancyString() :
                                    occupancyService.getRoomOccupancyString();
        }
    }
}
})();
